<template>
	<div class="row">
		<div class="col-12 text-center" v-if="!item">
			<div class="spinner-grow" role="status">
				<span class="sr-only">Loading...</span>
			</div>
		</div>

		<!-- main toolbar -->
		<div class="col-12" v-if="item">
			<div class="card">
				<div class="card-body">

					<div class="form-group float-left mr-2">
						<label for="item_name">Показывать на сайте</label><br>

						<input type="checkbox" id="switch_show" v-model="item.show" data-switch="success"
							@change="editItem()" />
						<label for="switch_show" data-on-label="Да" data-off-label="Нет"></label>
					</div>

					<div class="form-group float-left mr-2">
						<label for="item_name">Перейти на страницу на сайте</label><br>

						<a :href="app_frontend_host + `/partners?preview=true`"
							class="btn btn-sm btn-rounded btn-outline-primary" target="_blank">перейти</a>
					</div>

				</div>
			</div>
		</div>

		<div class="col-md-12 col-lg-6" v-if="item">
			<div class="card">
				<div class="card-body">
					<h5 class="text-muted">Полное описание</h5>
					<div class="form-group">
						<vue-editor v-model="item.description_full"
							:editorToolbar='[["bold", "italic", "underline"]]'></vue-editor>
					</div>

					<h5 class="text-muted">Короткое описание</h5>
					<div class="form-group">
						<vue-editor v-model="item.description_short"
							:editorToolbar='[["bold", "italic", "underline"]]'></vue-editor>
					</div>

					<button v-if="!loading" type="submit" class="btn btn-primary"
						@click.prevent="editItem()">Сохранить</button>
					<button v-else class="btn btn-primary" type="button" disabled>
						<span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
						Отправка данных...
					</button>

				</div>
			</div>

			<!-- photos -->
			<div class="card">
				<div class="card-body">
					<h3>Дополнительные фото</h3>

					<vue-dropzone ref="dropzone_photos" id="dropzone_photos" :options="dropzone_photos" class="mb-1"
						@vdropzone-sending="beforeImageUpload('photos', i, ...arguments)"
						@vdropzone-success="imageUploadSuccess('photos', i, ...arguments)"></vue-dropzone>

					<table v-if="item.photos && item.photos.length" class="table table-striped table-centered mb-1">
						<thead>
							<tr>
								<th>Photo</th>
								<th>Path</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(photo, i) in item.photos" :key="photo._id" v-if="photo.type == item._photos_type">
								<td class="table-photo">
									<a :href="getCDNUrl(photo.path)" target="_blank">
										<img :src="getCDNUrl(photo.path, ['r=100'])" alt="table-user" />
									</a>
								</td>
								<td>{{ photo.path }}</td>
								<td>
									<button class="btn btn-sm btn-outline-secondary mr-1"
										@click.prevent="photoSort(i, -1)"><i class="mdi mdi-chevron-double-up"></i></button>
									<button class="btn btn-sm btn-outline-secondary mr-3"
										@click.prevent="photoSort(i, 1)"><i
											class="mdi mdi-chevron-double-down"></i></button>

									<button class="btn btn-sm btn-danger" @click.prevent="deleteImage(i)"><i
											class="mdi mdi-window-close"></i></button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<div class="col-md-12 col-lg-6" v-if="item">
			<div class="card">
				<div class="card-body">
					<div class="form-group">
						<label>Название</label>
						<input type="text" v-model="item.title" class="form-control">
					</div>

					<div class="form-group">
						<label>Цена, €</label>
						<input type="number" v-model="item.price" class="form-control">
					</div>

					<div class="form-group">
						<label>Зона</label>
						<select class="form-control" v-model="item.zone">
							<option v-for="zone in zones" :key="zone._id" :value="zone._id">
								{{ zone.title }}</option>
						</select>
					</div>

					<div class="form-group">
						<label>Коллекция</label>
						<select class="form-control" v-model="item.setCollection">
							<option v-for="collection in collections" :key="collection._id" :value="collection._id">
								{{ collection.title }}</option>
						</select>
					</div>

					<div class="form-group ">
						<label>Основное изображение</label><br>
						<vue-dropzone class="mr-4" ref="dropzone_photo_main" id="dropzone_photo_main"
							:options="dropzone_photo_main"
							@vdropzone-sending="beforeImageUpload('photo_main', 'dropzone_photo_main', ...arguments)"
							@vdropzone-success="imageUploadSuccess('photo_main', 'dropzone_photo_main', ...arguments)"></vue-dropzone>
						<img :src="getCDNUrl(item.photo_main.path)" v-if="item.photo_main && item.photo_main.path"
							class="img-fluid mt-2">
					</div>

					<button v-if="!loading" type="submit" class="btn btn-primary"
						@click.prevent="editItem()">Сохранить</button>
					<button v-else class="btn btn-primary" type="button" disabled>
						<span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
						Отправка данных...
					</button>

				</div>
			</div>

			<div class="card">
				<div class="card-body">
					<h5>SEO settings</h5>
					<button v-if="!ai_loading" type="button" class="btn btn-info" @click.prevent="aiSEO()">заполнить с
						помощью AI</button>
					<button v-else class="btn btn-info" type="button" disabled>
						<span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
						Отправка данных...
					</button>

					<p>Важно, чтобы текстовые поля на странице была заполнена, чтобы AI смог взять их за контекст</p>

					<div class="form-group">
						<label>SEO title</label>
						<input type="text" v-model="item.seo.title" class="form-control">
					</div>

					<div class="form-group">
						<label>SEO description</label>
						<textarea v-model="item.seo.description" class="form-control"></textarea>
					</div>

					<div class="form-group">
						<label>SEO keywords</label>
						<input type="text" v-model="item.seo.keywords" class="form-control">
					</div>


					<button v-if="!loading" type="submit" class="btn btn-primary"
						@click.prevent="editItem()">Сохранить</button>
					<button v-else class="btn btn-primary" type="button" disabled>
						<span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
						Отправка данных...
					</button>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { VueEditor } from "vue2-editor";
import vue2Dropzone from 'vue2-dropzone'

import log from '@/plugins/log'
import { to } from '@/plugins/utils'
import '@/plugins/quill'

import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
	name: 'ShopSetEdit',
	data: () => {
		return {
			item: null,
			collections: [],
			zones: [],
			loading: false,
			ai_loading: false,
			dropzoneOptions: {
				paramName: "image",
				acceptedFiles: 'image/*',
				parallelUploads: 1,
				createImageThumbnails: false
			}
		}
	},
	computed: {
		...mapState([
			'app_mongo_desc',
			'app_cdn_host',
			'backend_url',
			'app_token',
			'app_frontend_host'
		]),
		id() {
			return this.$route.params.id
		},
		dropzone_photo_main() {
			return Object.assign({}, this.dropzoneOptions, {
				url: this.backend_url + '/shop_set/uploadImage/' + this.id,
				maxFiles: 1,
				headers: {
					'Authorization': this.app_token,
					'x-upload-type': 'photo_main'
				}
			})
		},
		dropzone_photos() {
			return Object.assign({}, this.dropzoneOptions, {
				url: this.backend_url + '/shop_set/uploadImage/' + this.id,
				headers: {
					'Authorization': this.app_token
				}
			})
		}
	},
	async beforeMount() {
		await Promise.all([
			this.getItem(),
			this.getCollections(),
			this.getZones()
		])
	},
	mounted() {
		log.debug(`/views/shop_set/edit/${this.id}`, 'mounted')
	},
	methods: {
		async getItem() {
			var [err, response] = await to(this.$http.get(`/shop_set/edit/${this.id}`))
			if (err) {
				log.error(`/views/shop_set/edit/${this.id}`, 'methods.getItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if (!response.data.success) {
				log.error(`/views/shop_set/edit/${this.id}`, 'methods.getItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}

			log.debug('/views/shop_set/add', 'methods.getItem', '$http.request', response.data)

			this.item = response.data.item
		},

		async getCollections() {
			var [err, response] = await to(this.$http.get(`/shop_set_collection/list`))
			if (err) {
				log.error(`/views/shop_set/edit/${this.id}`, 'methods.getCollections', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if (!response.data.success) {
				log.error(`/views/shop_set/edit/${this.id}`, 'methods.getCollections', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}

			log.debug('/views/shop_set/add', 'methods.getCollections', '$http.request', response.data)

			this.collections = response.data.items.filter(item => !item.deleted && item.show);
		},

		async getZones() {
			var [err, response] = await to(this.$http.get(`/shop_set_zone/list`))
			if (err) {
				log.error(`/views/shop_set/edit/${this.id}`, 'methods.getZones', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if (!response.data.success) {
				log.error(`/views/shop_set/edit/${this.id}`, 'methods.getZones', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}

			log.debug('/views/shop_set/add', 'methods.getZones', '$http.request', response.data)

			this.zones = response.data.items.filter(item => !item.deleted && item.show);
		},

		async editItem() {
			this.loading = true

			var [err, response] = await to(this.$http.post(`/shop_set/edit/${this.id}`, this.item))
			if (err) {
				this.loading = false
				log.error(`/views/shop_set/edit/${this.id}`, 'methods.editItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if (!response.data.success) {
				this.loading = false
				log.error(`/views/shop_set/edit/${this.id}`, 'methods.editItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}

			this.loading = false
			log.debug(`/views/shop_set/edit/${this.id}`, 'methods.editItem', '$http.request', response.data)
			$.NotificationApp.send("Успешно", '', "top-right", "", "success")


			this.item = response.data.item
		},

		async aiSEO() {
			this.ai_loading = true;

			const collection = this.collections.find(item => item._id === this.item.setCollection);

			var [err, response] = await to(this.$http.post(`/seo/generate`, {
				prompt: [
					`Type: Store quick design set`,
					`Name: ${this.item.title}`,
					`Description: ${this.item.description_full}`,
					`Room: ${this.item.room}`,
					`Collection: ${collection.title}`
				].join(';')
			}))

			if (err) {
				this.ai_loading = false
				log.error(`/views/blog/edit/${this.id}`, 'methods.aiSEO', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if (!response.data.success) {
				this.ai_loading = false
				log.error(`/views/blog/edit/${this.id}`, 'methods.aiSEO', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}

			this.ai_loading = false

			this.item.seo.title = response.data.result.title;
			this.item.seo.description = response.data.result.description;
			this.item.seo.keywords = response.data.result.keywords;
		},

		photoSort(index, direction) {
			let photos = []
			this.item.photos.forEach((photo, i) => {
				if (photo.type == this.item._photos_type)
					photos.push(i)
			})

			let filteredIndex = photos.indexOf(index)
			if (filteredIndex == -1) return;

			let obj1 = this.item.photos[index]
			let obj2 = this.item.photos[photos[filteredIndex + direction]]

			if (obj1 && obj2) {
				this.$set(this.item.photos, index, obj2)
				this.$set(this.item.photos, photos[filteredIndex + direction], obj1)
			}
		},
		deleteImage(photoIndex) {
			if (!confirm('Уверены, что хотите удалить фото?')) return;

			this.item.photos.splice(photoIndex, 1);
		},

		/* dropzone upload */
		beforeImageUpload(type, ref, file, xhr, formData) {
			formData.append('type', type)
		},
		imageUploadSuccess(type, ref, file, response) {
			if (!response.success) {
				log.error(`/views/shop_set/edit/${this.id}`, 'methods.imageUploadSuccess', '$http.response', response)
				return $.NotificationApp.send("Ошибка", response.error, "top-right", "", "error")
			}

			if (type == 'photo_main') {
				this.item.photo_main = {
					url: this.getCDNUrl(response.image.imagePath),
					path: response.image.imagePath
				}
				this.editItem()

				this.$refs[ref].removeAllFiles()
			}
			if (type == 'photos') {
				if (!this.item.photos) this.item.photos = []
				this.item.photos.push(Object.assign({}, this.roomPhotoDesc, {
					url: response.image.imageUrl,
					path: response.image.imagePath,
				}))

				this.editItem()
			}
		},

		getCDNUrl(path, modify = []) {
			let modification_string = modify.length ? modify.join(',') + '/_/' : ''
			return `${this.app_cdn_host}/i/${modification_string}${path}`
		}
	},
	components: {
		VueEditor,
		vueDropzone: vue2Dropzone,
	},
};
</script>

<style scoped>
#dropzone_photo_main {
	display: inline-block;
}
</style>